const getDefaultState = () => ({
  xmlChannels: {
    items: [],
    loading: false,
    error: undefined,
    xmlChannel: undefined,
  },
  addons: {
    items: [],
    loading: false,
    error: undefined,
    update: {
      inProgressItems: {},
      errorItems: {},
    },
    search: undefined,
    addon: {
      id: undefined,
      addonName: undefined,
      showProductNames: false,
      xmlChannelProducts: [],
    },
  },
});

export default getDefaultState;




// WEBPACK FOOTER //
// ./src/store/modules/ski/visitgroup/defaultState.js